import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {GlobalVariable} from '../../global';
import {
  FieldRequestParameters,
  GroupByRequestParameters,
  OrderByRequestParameters,
  RequestParameters
} from '../../shared/models/request-parameters/parameter.model';
import {DatePipe} from '@angular/common';

@Injectable()
export class ReportsService {

  reportsSack: any;
  reportParameters: any;

  constructor(private http: HttpClient) { }

  getReport(parameters: any) {
    this.reportParameters = parameters;
    const params = this.normalizeReportParameters(parameters);

    return this.http.get(GlobalVariable.BASE_API_URL + '/report/operations', {
        params: params.getHttpParams(),
      }
    ).map(
      (response: any) => {
        this.reportsSack = response;
        return response;
      }
    );
  }

  getDailyReportByCountry(parameters: any) {
    const params = this.normalizeReportParameters(parameters);

    return this.http.get(GlobalVariable.BASE_API_URL + '/report/operations', {
        params: params.getHttpParams(),
      }
    ).map(
      (response: any) => {
        this.reportsSack = response;
        return response;
      }
    );
  }

  normalizeReportParameters(parameters: any): RequestParameters {

    const requestParameters = new RequestParameters();

    const datePipe = new DatePipe('en');
    const dates = parameters.fields.operationDate;
    const date1 = datePipe.transform(dates.value, 'yyyy-MM-ddT00:00:00');
    const date2 = datePipe.transform(dates.value2, 'yyyy-MM-ddT23:59:59');
    const reqDateParameter = new FieldRequestParameters('operationDate', null, date1, date2);
    requestParameters.fields.push(reqDateParameter);
    if(parameters.fields.amount){
      const amount = parameters.fields.amount;
    const reqAmount = new FieldRequestParameters('amount',null, amount.lowerValue,amount.upperValue);
    requestParameters.fields.push(reqAmount);
    }
    if (parameters.fields.organization !== undefined && parameters.fields.organization !== null) {
      const reqOrganizationParameter = new FieldRequestParameters(
        'organization',
        parameters.fields.organization.reference
      );
      requestParameters.fields.push(reqOrganizationParameter);
    }

    if (parameters.fields.agency !== undefined && parameters.fields.agency !== null) {
      const reqAgencyParameter = new FieldRequestParameters(
        'agency',
        parameters.fields.agency.reference
      );
      requestParameters.fields.push(reqAgencyParameter);
    }

    if (parameters.fields.callCenter !== undefined && parameters.fields.callCenter !== null) {
      const reqCallCenterParameter = new FieldRequestParameters(
        'callCenter',
        parameters.fields.callCenter.reference
      );
      requestParameters.fields.push(reqCallCenterParameter);
    }

    if (parameters.fields.userOperatorPartner !== undefined && parameters.fields.userOperatorPartner !== null) {
      const reqUserOperatorPartnerParameter = new FieldRequestParameters(
        'userOperatorPartner',
        parameters.fields.userOperatorPartner.reference
      );
      requestParameters.fields.push(reqUserOperatorPartnerParameter);
    }

    if (parameters.fields.userOperatorClk !== undefined && parameters.fields.userOperatorClk !== null) {
      const reqUserOperatorClkParameter = new FieldRequestParameters(
        'userOperatorClk',
        parameters.fields.userOperatorClk.reference
      );
      requestParameters.fields.push(reqUserOperatorClkParameter);
    }

    if (parameters.fields.account !== undefined && parameters.fields.account !== null) {
      const reqAccountParameter = new FieldRequestParameters(
        'account',
        parameters.fields.account.reference
      );
      requestParameters.fields.push(reqAccountParameter);
    }

    if (parameters.groupBy !== undefined && parameters.groupBy !== null) {
      for (const key in parameters.groupBy) {
        if (parameters.groupBy.hasOwnProperty(key)) {
          const reqUserOperatorPartnerParameter = new GroupByRequestParameters(
            parameters.groupBy[key].value
          );
          requestParameters.groupBy.push(reqUserOperatorPartnerParameter);
        }
      }
    }

    if (parameters.orderBy !== undefined && parameters.orderBy !== null) {
      for (const key in parameters.orderBy) {
        if (key) {
          const reqUserOperatorPartnerParameter = new OrderByRequestParameters(
            parameters.orderBy[key].field,
            parameters.orderBy[key].value
          );
          requestParameters.orderBy.push(reqUserOperatorPartnerParameter);
        }
      }
    }

    if (parameters.fields.operationType !== undefined && parameters.fields.operationType !== null) {
      for (const key in parameters.fields.operationType) {
        if (parameters.fields.operationType.hasOwnProperty(key)) {
          const reqUserOperationTypeParameter = new FieldRequestParameters(
            'operationType',
            parameters.fields.operationType[key].value,
          );
          requestParameters.fields.push(reqUserOperationTypeParameter);
        }
      }
    }
    if (parameters.fields.status) {
      for (const key in parameters.fields.status) {
        if (parameters.fields.status.hasOwnProperty(key)) {
          const reqUserStatusParameter = new FieldRequestParameters(
            'status',
            parameters.fields.status[key].value,
          );
          requestParameters.fields.push(reqUserStatusParameter);
        }
      }
    }

    requestParameters.limit = -1;

    return requestParameters;
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/report/reports/reports.service.ts